import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { BackToDashboardButton } from '../../../common/components/navigation';

interface WorkflowListHeaderProps {
  onCreateClick: () => void;
}

const WorkflowListHeader: React.FC<WorkflowListHeaderProps> = ({ onCreateClick }) => (
  <Box
    sx={{
      backgroundColor: '#ffffff',
      borderBottom: '2px solid #3b82f6',
      p: 2.5,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}
  >
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 700, color: '#1e293b', mb: 0.5 }}>
        Workflow Management
      </Typography>
      <Typography variant="body2" sx={{ color: '#64748b' }}>
        Configure and manage automated workflows for ticket processing
      </Typography>
    </Box>
    <Box display="flex" gap={1}>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={onCreateClick}
        sx={{
          backgroundColor: '#162346',
          '&:hover': { backgroundColor: '#1a2a52' },
          fontWeight: 600,
          textTransform: 'none',
          px: 3,
        }}
      >
        Create Workflow
      </Button>
      <BackToDashboardButton />
    </Box>
  </Box>
);

export default WorkflowListHeader;
